import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

import { invoiceQueryLinkerSchema } from '../../../../invoices/shared/schemas/invoices/invoice-query-linker-schema';

export const paymentType = z.enum(['payment', 'refund']);
export type PaymentType = z.infer<typeof paymentType>;

export const paymentStatus = z.enum(['paid', 'pending', 'overpaid', 'credit', 'refund']);
export type PaymentStatus = z.infer<typeof paymentStatus>;

export const agreementPaymentQuerySchema = z.object({
  id: z.number(),
  agreement_installment_id: z.number(),
  amount: currencyInput.querySchema(),
  payment_date: z.string(),
  payment_type: paymentType,
  payment_status: paymentStatus,
});

export type AgreementPaymentQuerySchema = z.infer<typeof agreementPaymentQuerySchema>;

export const agreementInstallmentsQuerySchema = z.object({
  id: z.number(),
  agreement_id: z.number(),
  wholesale_amount: currencyInput.querySchema(),
  contracted_amount: currencyInput.querySchema(),
  due_date: z.string(),
  invoice_number: z.string(),
  paid: z.boolean(),
  date_paid_in_full: z.string().nullish(),
  remaining_balance: z.number().nullish(),
  agreement_payments: z.array(agreementPaymentQuerySchema).nullish(),
  invoice_id: z.number().nullable(),
  invoice: invoiceQueryLinkerSchema.nullable(),
});

export type AgreementInstallmentsQuerySchema = z.infer<typeof agreementInstallmentsQuerySchema>;
